import { z } from 'zod';

export const formFieldSchema = z.object({
  key: z.string(),
  label: z.string(),
  type: z.enum(['text', 'textarea', 'number', 'select', 'date']),
  required: z.boolean().default(false),
  options: z.array(z.object({ value: z.string(), label: z.string() })).optional(),
});

export const formFillPayloadSchema = z.object({
  schema: z.object({
    id: z.number(),
    name: z.string(),
    fields: z.array(formFieldSchema),
  }),
  initial: z.record(z.string(), z.unknown()).optional(),
});

export type FormFillField = z.infer<typeof formFieldSchema>;
export type FormFillPayload = z.infer<typeof formFillPayloadSchema>;
